<template>
  <div class="add-quality-guarantee">
    <div class="form-content">
      <el-form>
        <!-- 语言 + 排序 -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="语言" required>
              <el-select v-model="currentData.language_code" placeholder="请选择语言">
                <el-option v-for="item in languageList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number v-model="currentData.sort_order" :min="0" :max="999" controls-position="right" />
              <span style="margin-left: 10px; font-size: 12px; color: #909399;">数值越小越靠前</span>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 图标 -->
        <el-form-item label="图标">
          <div class="icon-picker-wrapper">
            <el-input v-model="currentData.icon" placeholder="请输入图标类名，如 fas fa-shield-alt">
              <template slot="prepend">
                <i :class="currentData.icon || 'el-icon-question'" style="font-size: 16px;"></i>
              </template>
            </el-input>
            <div class="icon-preview">
              <div class="icon-preview-label">预览：</div>
              <i v-if="currentData.icon" :class="currentData.icon" style="font-size: 28px; color: #409EFF;"></i>
              <span v-else style="color: #909399; font-size: 12px;">输入图标类名后预览</span>
            </div>
            <div class="icon-common">
              <span class="icon-common-label">常用图标：</span>
              <span
                v-for="icon in commonIcons"
                :key="icon"
                class="icon-common-item"
                :class="{ active: currentData.icon === icon }"
                @click="currentData.icon = icon"
              >
                <i :class="icon"></i>
              </span>
            </div>
          </div>
        </el-form-item>

        <!-- 标题 -->
        <el-form-item label="标题" required>
          <el-input v-model="currentData.title" placeholder="请输入质量保障标题" />
        </el-form-item>

        <!-- 描述 -->
        <el-form-item label="描述">
          <el-input
            v-model="currentData.description"
            type="textarea"
            :rows="3"
            placeholder="请输入描述（选填）"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getLanguage } from '@/api/public'
import { addQualityGuarantee, updateQualityGuarantee } from '@/api/website'

export default {
  name: 'AddQualityGuarantee',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      languageList: [],
      currentData: {
        language_code: 'zh',
        icon: '',
        title: '',
        description: '',
        sort_order: 0
      },
      commonIcons: [
        'fas fa-shield-halved',
        'fas fa-microscope',
        'fas fa-clipboard-check',
        'fas fa-award',
        'fas fa-certificate',
        'fas fa-check-double',
        'fas fa-screwdriver-wrench',
        'fas fa-gears'
      ]
    }
  },
  watch: {
    item: {
      handler(newItem) {
        if (newItem) {
          this.resetForm()
          this.currentData = {
            id: newItem.id,
            language_code: newItem.language_code || 'zh',
            icon: newItem.icon || '',
            title: newItem.title || '',
            description: newItem.description || '',
            sort_order: newItem.sort_order || 0
          }
        } else {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getLanguageList()
  },
  methods: {
    async getLanguageList() {
      try {
        const res = await getLanguage()
        this.languageList = res.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    resetForm() {
      this.currentData = {
        language_code: 'zh',
        icon: '',
        title: '',
        description: '',
        sort_order: 0
      }
    },
    handleSubmit() {
      if (!this.currentData.language_code) {
        this.$message.error('请选择语言')
        return
      }
      if (!this.currentData.title) {
        this.$message.error('请输入标题')
        return
      }

      var submitData = { ...this.currentData }
      var isEdit = submitData.id

      var apiCall = isEdit
        ? updateQualityGuarantee(submitData.id, submitData)
        : addQualityGuarantee(submitData)

      apiCall.then(res => {
        if (res.code === 200) {
          this.resetForm()
          this.$emit('save', true)
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }).catch(() => {
        this.$message.error('保存失败')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-quality-guarantee {
  box-sizing: border-box;
  padding: 0 20px;
}

.form-content {
  box-sizing: border-box;
  margin-bottom: 30px;
}

.icon-picker-wrapper {
  width: 100%;
}

.icon-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}

.icon-preview-label {
  font-size: 12px;
  color: #909399;
}

.icon-common {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.icon-common-label {
  font-size: 12px;
  color: #909399;
  margin-right: 4px;
}

.icon-common-item {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: #606266;
  transition: all 0.2s;
}

.icon-common-item:hover {
  border-color: #409EFF;
  color: #409EFF;
}

.icon-common-item.active {
  border-color: #409EFF;
  color: #409EFF;
  background-color: #ecf5ff;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式 */
@media (max-width: 768px) {
  .add-quality-guarantee {
    padding: 10px 0;
  }

  .form-content {
    margin-bottom: 20px;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions .el-button {
    width: 100%;
  }
}
</style>
